import { Container } from "@mui/system";
import { Grid, Typography, Button, Avatar, FormControl, Select, Box, Chip, MenuItem, IconButton, TextField, Alert, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import globals from "../globals";
import RTE from "../components/course_edit/rich_text_editor";
import CancelIcon from '@mui/icons-material/Cancel'
import { useAuth } from '../context/AuthContext';

const user = {

}

const hours = [
    "9:00 - 10:00",
    "10:00 - 11:00",
    "11:00 - 12:00",
    "12:00 - 13:00",
    "13:00 - 14:00",
    "14:00 - 15:00",
    "15:00 - 16:00",
    "16:00 - 17:00",
    "17:00 - 18:00",
    "18:00 - 19:00",
    "19:00 - 20:00",
    "20:00 - 21:00",
];

const days = [
    "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота", "Неделя"
]

const dayToTimeslotKey = {
    "Понеделник": "monday",
    "Вторник": "tuesday",
    "Сряда": "wednesday",
    "Четвъртък": "thursday",
    "Петък": "friday",
    "Събота": "saturday",
    "Неделя": "sunday",
}

const CALENDAR_HEIGHT = 48;
const CALENDAR_PADDIONG_TOP = 8;

const CalendarProps = {
    PaperProps: {
        style: {
            maxHeight: CALENDAR_HEIGHT * 4.5 + CALENDAR_PADDIONG_TOP,
            width: 250,
        },
    },
};

const EditPage = () => {
    const { instructorId } = useParams();
    const { token } = useAuth();
    const [displayName, setDisplayName] = useState('');
    const [slugInput, setSlugInput] = useState('');
    const [slugFeedback, setSlugFeedback] = useState({ severity: 'info', text: '' });
    const [checkLoading, setCheckLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [profileSaveLoading, setProfileSaveLoading] = useState(false);
    const [profileLoading, setProfileLoading] = useState(true);
    const [profileError, setProfileError] = useState('');
    const [profileSaveFeedback, setProfileSaveFeedback] = useState({ severity: 'info', text: '' });
    const [profileForm, setProfileForm] = useState({ description: '', education: '' });

    const [avatar, setAvatar] = useState((user) ? user.image_url : 0);
    const [avatarFile, setAvatarFile] = useState(null);
    const [instructorData, setInstructorData] = useState({});
    const [calendar, setCalendar] = useState({
        'Понеделник': [],
        'Вторник': [],
        'Сряда': [],
        'Четвъртък': [],
        'Петък': [],
        'Събота': [],
        'Неделя': [],
    });

    useEffect(() => {
        if (!instructorId || !token)
            return;
        let cancelled = false;
        setProfileLoading(true);
        setProfileError('');
        fetch(`${globals.apiUrl}/admin/instructor/${instructorId}`,
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`
                }
            }
        )
            .then((r) => {
                if (!r.ok)
                    throw new Error('Неуспешно зареждане на учителя');
                return r.json();
            })
            .then((data) => {
                if (!cancelled) {
                    const n = `${data.first_name || ''} ${data.last_name || ''}`.trim();
                    setDisplayName(n || 'Учител');
                    setInstructorData(data);
                    setProfileForm({
                        description: data.description || '',
                        education: data.education || '',
                    });
                    const ts = data.timeslots || {};
                    setCalendar({
                        'Понеделник': ts.monday || [],
                        'Вторник': ts.tuesday || [],
                        'Сряда': ts.wednesday || [],
                        'Четвъртък': ts.thursday || [],
                        'Петък': ts.friday || [],
                        'Събота': ts.saturday || [],
                        'Неделя': ts.sunday || [],
                    });
                }
            })
            .catch(() => {
                if (!cancelled)
                    setProfileError('Профилът не можа да бъде зареден.');
            })
            .finally(() => {
                if (!cancelled)
                    setProfileLoading(false);
            });
        return () => { cancelled = true; };
    }, [instructorId, token]);

    useEffect(() => {
        if (!instructorId || !token)
            return;
        let cancelled = false;
        fetch(`${globals.apiUrl}/admin/url-slugs?target_type=instructor&target_id=${encodeURIComponent(instructorId)}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        })
            .then((r) => r.ok ? r.json() : null)
            .then((data) => {
                if (!cancelled && data && data.slug)
                    setSlugInput(data.slug);
            })
            .catch(() => { });
        return () => { cancelled = true; };
    }, [instructorId, token]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatar(URL.createObjectURL(file));
            setAvatarFile(file);
        }
    };

    const handleCalendarChange = (day) => (event) => {
        const { value } = event.target;
        setCalendar((prev) => ({
            ...prev,
            [day]: typeof value === "string" ? value.split(",") : value,
        }));
    };

    const handleProfileFormChange = (event) => {
        setProfileForm((prev) => ({
            ...prev,
            [event.target.id]: event.target.value,
        }));
    };

    const buildTimeslotsPayload = () => {
        const timeslots = {};
        days.forEach((day) => {
            timeslots[dayToTimeslotKey[day]] = calendar[day] || [];
        });
        return timeslots;
    };

    const handleSaveProfile = async () => {
        if (!instructorId || !token)
            return;
        setProfileSaveLoading(true);
        setProfileSaveFeedback({ severity: 'info', text: '' });
        try {
            const formData = new FormData();
            formData.append('data', JSON.stringify({
                description: profileForm.description,
                education: profileForm.education,
                timeslots: buildTimeslotsPayload(),
            }));
            if (avatarFile)
                formData.append('file', avatarFile);

            const r = await fetch(`${globals.apiUrl}/admin/instructor/${instructorId}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setProfileSaveFeedback({
                    severity: 'error',
                    text: data.detail || 'Неуспешен запис на профила.',
                });
                return;
            }
            setInstructorData(data);
            setProfileForm({
                description: data.description || '',
                education: data.education || '',
            });
            const ts = data.timeslots || {};
            setCalendar({
                'Понеделник': ts.monday || [],
                'Вторник': ts.tuesday || [],
                'Сряда': ts.wednesday || [],
                'Четвъртък': ts.thursday || [],
                'Петък': ts.friday || [],
                'Събота': ts.saturday || [],
                'Неделя': ts.sunday || [],
            });
            if (data.image_url)
                setAvatar(data.image_url);
            setAvatarFile(null);
            setProfileSaveFeedback({ severity: 'success', text: 'Профилът е запазен успешно.' });
        } catch {
            setProfileSaveFeedback({ severity: 'error', text: 'Мрежова грешка при записа.' });
        } finally {
            setProfileSaveLoading(false);
        }
    };

    const handleCheckSlug = async () => {
        if (!instructorId || !token)
            return;
        setCheckLoading(true);
        setSlugFeedback({ severity: 'info', text: '' });
        try {
            const q = new URLSearchParams({
                slug: slugInput.trim(),
                target_type: 'instructor',
                exclude_target_id: String(instructorId),
            });
            const r = await fetch(`${globals.apiUrl}/admin/url-slugs/availability?${q}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setSlugFeedback({ severity: 'error', text: data.detail || 'Грешка при проверката' });
                return;
            }
            if (data.available)
                setSlugFeedback({ severity: 'success', text: 'Този адрес е свободен.' });
            else
                setSlugFeedback({ severity: 'warning', text: data.reason || 'Адресът не е свободен.' });
        } catch {
            setSlugFeedback({ severity: 'error', text: 'Мрежова грешка при проверката.' });
        } finally {
            setCheckLoading(false);
        }
    };

    const handleSaveSlug = async () => {
        if (!instructorId || !token)
            return;
        setSaveLoading(true);
        setSlugFeedback({ severity: 'info', text: '' });
        try {
            const q = new URLSearchParams({
                slug: slugInput.trim(),
                target_type: 'instructor',
                exclude_target_id: String(instructorId),
            });
            const check = await fetch(`${globals.apiUrl}/admin/url-slugs/availability?${q}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const checkData = await check.json().catch(() => ({}));
            if (!check.ok || !checkData.available) {
                setSlugFeedback({
                    severity: 'error',
                    text: checkData.reason || checkData.detail || 'Адресът не е наличен за запис.',
                });
                setSaveLoading(false);
                return;
            }
            const tid = parseInt(instructorId, 10);
            const r = await fetch(`${globals.apiUrl}/admin/url-slugs`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    slug: slugInput.trim(),
                    target_type: 'instructor',
                    target_id: tid,
                }),
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setSlugFeedback({ severity: 'error', text: data.detail || 'Неуспешен запис' });
                return;
            }
            if (data.slug)
                setSlugInput(data.slug);
            setSlugFeedback({ severity: 'success', text: 'Записано. Публичен път: /instructor/' + (data.slug || slugInput.trim()) });
        } catch {
            setSlugFeedback({ severity: 'error', text: 'Мрежова грешка при записа.' });
        } finally {
            setSaveLoading(false);
        }
    };

    const profileReady = !profileLoading && !profileError && instructorData.id;
    return (
        <Container sx={{ mb: 4 }}>
            {profileLoading ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8, gap: 2 }}>
                    <CircularProgress sx={{ color: globals.colors.darkBlue }} />
                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>
                        Зареждане на профила...
                    </Typography>
                </Box>
            ) : null}
            {!profileLoading && profileError ? (
                <Alert severity="error" sx={{ mt: 5 }}>{profileError}</Alert>
            ) : null}
            {profileReady ? (
            <>
            <Grid container direction={'column'} sx={{ mt: 5 }}>
                <Typography sx={{ color: globals.colors.textColor, fontSize: 20, mb: 3, fontWeight: 'bold' }}>
                    Редактиране на профила на {displayName}
                </Typography>
                <Grid item sx={{ mt: 1, mb: 3 }}>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Short url"
                                variant="filled"
                                value={slugInput}
                                onChange={(e) => setSlugInput(e.target.value)}
                                helperText="Само малки букви, цифри и тире (напр. ivan-ivanov). Публичен адрес: /instructor/…"
                                sx={{ minWidth: 260 }}
                            />
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                loading={checkLoading}
                                variant='contained'
                                size={'small'}
                                onClick={handleCheckSlug}
                                sx={{ backgroundColor: globals.colors.darkBlue, textTransform: 'none', mt: 2 }}
                            >
                                Провери
                            </LoadingButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                loading={saveLoading}
                                variant='contained'
                                size={'small'}
                                onClick={handleSaveSlug}
                                sx={{ backgroundColor: globals.colors.lightGreen, textTransform: 'none', mt: 2 }}
                            >
                                Запази
                            </LoadingButton>
                        </Grid>
                    </Grid>
                    {slugFeedback.text ? (
                        <Alert severity={slugFeedback.severity} sx={{ mt: 2, maxWidth: 640 }}>
                            {slugFeedback.text}
                        </Alert>
                    ) : null}
                </Grid>
                <Grid item>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Avatar
                                src={avatar || instructorData.image_url}
                                sx={{ width: 90, height: 90 }}
                            />
                        </Grid>
                        <Grid item>
                            <Typography sx={{ color: globals.colors.gray, fontSize: 12, mx: 2, mt: 2 }}>JPG или PNG</Typography>
                            <Button variant='contained' component='label' size={'small'} sx={{
                                backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                    backgroundColor: globals.colors.darkRed
                                },
                            }}>
                                Смени снимката
                                <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={handleImageChange}
                                />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 5 }}>
                <Grid item sm={12}>
                    <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Биография</Typography>
                    <RTE onChange={handleProfileFormChange} idName="description" defaultValue={profileForm.description} />
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 5 }}>
                <Grid item sm={12}>
                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>Образование и опит</Typography>
                    <Typography sx={{ mb: 1, color: globals.colors.gray, fontWeight: 'bold', fontSize: 12 }}>(Моля, напишете ги едно под друго)</Typography>
                    <RTE onChange={handleProfileFormChange} idName="education" defaultValue={profileForm.education} />
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 5 }}>
                <Typography sx={{ color: globals.colors.textColor, fontSize: 20, mb: 3, fontWeight: 'bold' }}>Редактиране на график</Typography>
            </Grid>
            {days.map((day) => (
                <Grid key={day} sx={{ mb: 3 }}>
                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>{day}</Typography>
                    <Grid container sx={{ mt: 1 }}>
                        <FormControl sx={{ width: 400 }}>
                            <Select
                                multiple
                                value={calendar[day] || []}
                                onChange={handleCalendarChange(day)}
                                renderValue={(selected) => (
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={CalendarProps}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: globals.colors.darkRed,
                                    },
                                }}
                            >
                                {hours.map((hour) => (
                                    <MenuItem key={hour} value={hour}>
                                        {hour}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            ))}
            {profileSaveFeedback.text ? (
                <Alert severity={profileSaveFeedback.severity} sx={{ mt: 2, maxWidth: 640 }}>
                    {profileSaveFeedback.text}
                </Alert>
            ) : null}
            <Grid container spacing={5}>
                <Grid item>
                    <LoadingButton
                        loading={profileSaveLoading}
                        variant='contained'
                        size='large'
                        onClick={handleSaveProfile}
                        sx={{
                            mt: 3, px: 5, backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                backgroundColor: globals.colors.darkRed,
                            },
                        }}
                    >
                        Запази
                    </LoadingButton>
                </Grid>
                <Grid item>
                    <IconButton
                        sx={{ mt: 3, color: globals.colors.textColor }}
                        onClick={() => setCalendar(days.reduce((acc, day) => ({ ...acc, [day]: [] }), {}))}
                        aria-label="Изчисти графика"
                    >
                        <CancelIcon />
                    </IconButton>
                </Grid>
            </Grid>
            </>
            ) : null}
        </Container>
    )
}

export default EditPage
